document.addEventListener('DOMContentLoaded', function () {
  const mq = window.matchMedia('(max-width: 749px)');
  const main = document.querySelector('main#MainContent');

  // Sections
  const announcement = document.getElementById('shopify-section-template--24014249656605__section_announcement_q9jGWt');
  const collections  = document.getElementById('shopify-section-template--24014249656605__section_collections_list_a3KAkN');
  const slideshow    = document.getElementById('shopify-section-template--24014249656605__slideshow');

  if (!main || !announcement || !collections || !slideshow) return;

  // Desktop order is already correct (Announcement → Collections → Slideshow)
  // On mobile we want (Slideshow → Announcement → Collections)
  function reorder() {
    if (mq.matches) {
      // Mobile order
      main.insertBefore(slideshow, announcement);
      main.insertBefore(announcement, collections);
    } else {
      // Desktop order
      main.insertBefore(announcement, collections);
      main.insertBefore(collections, slideshow);
    }
  }

  reorder();
  (mq.addEventListener ? mq.addEventListener('change', reorder) : mq.addListener(reorder));

  // Support Theme Editor live preview reloads
  document.addEventListener('shopify:section:load', reorder);
  document.addEventListener('shopify:section:reorder', reorder);
});